import React, { useState } from "react";
import AccordBtn from "../../../../core-components/AccordBtn/AccordBtnUI";
import * as S from "./SafetyInformation.styles";

interface IData {
  title: string;
  item_list: Array<string>
}

interface SafetyInformationProps {
  header: string,
  margin: string,
  data: Array<IData>
}

const SafetyInformationUI: React.FC<SafetyInformationProps> = ({ header = '', margin, data = [] }) => {
  const [toggle, setToggle] = useState(true);

  const handlePolicy = () => {
    setToggle(!toggle);
  };
  return (
    <>
      {data?.length ? (
        <S.SafetyInfoCont margin={margin}>
          <S.SafetyInfoHeader onClick={handlePolicy}>
            <div>{header ? <h3>{header}</h3> : null}</div>
            <AccordBtn active={toggle} />
          </S.SafetyInfoHeader>
          {toggle && (
            <S.SafetyInfoContent>
              {data?.length ? data?.map(({ title = '', item_list = [] }) => {
                return (
                  <div>
                    <h4>{title}</h4>
                    <ul className="infoList">
                      {item_list.map((data, index) => (
                        <li key={`infoList${index}`}>{data}</li>
                      ))}
                    </ul>
                  </div>
                )
              }) : null}
            </S.SafetyInfoContent>
          )}
        </S.SafetyInfoCont>
      ) : null}
    </>
  );
};

export default SafetyInformationUI;
